const mobileWidth = window.mobWidth || 520;

if (window.innerWidth < mobileWidth) {
        const io = new IntersectionObserver((entries) => {
            let btn = document.getElementById("cta-floating");
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                btn.style.display = "none";
            }
            if (!entry.isIntersecting) { 
                    btn.style.display = "block";
                }
            });
        });

        // Declares what to observe, and observes its properties.
        const hasCtaElList = document.querySelectorAll(".has-cta");
        hasCtaElList.forEach((el) => {
            io.observe(el);
        });


    }